import junctions from './list_junction.json' ;

export function getFcdIntersections() {
// Keep only one item per unique junction_id
    const uniqueByJunctionId = Array.from(
        new Map(junctions.map(item => [item.junction_id, item])).values()
    );

    return uniqueByJunctionId;
}